<script setup>

import {inject} from 'vue'
import MovingTooltip from "@/components/common/other/MovingTooltip";
import AuthorizeLogin from "@/classes/login/AuthorizeLogin";


const sideMenuItems = inject("sideMenuItems")

const openMenu = (menuItem) => {

  for (let item in sideMenuItems.value) {

    sideMenuItems.value[item].active = false;
  }

  menuItem.active = true;
}

</script>

<template>
  <div id="Vue-3-component-side-menu" class="side-menu">
<!--    <div class="side-menu-icons" v-for="item in sideMenuItems">-->
<!--      <MovingTooltip>-->
<!--        <div :class="`${item.active && 'side-menu-icon-active' }`" @click="openMenu(item)" v-html="item.icon">-->
<!--        </div>-->
<!--        <template #content>{{item.title}}</template>-->
<!--      </MovingTooltip>-->
<!--    </div>-->
    <div class="side-menu-icons">
      <div class="side-menu-logo"><span>BOXTRAX</span><span style="color: #ffa834">vision</span></div>
    </div>
    <div>
      <MovingTooltip>
        <div class="side-menu-log-out" @click="AuthorizeLogin.logout()">
          <i class="fa-duotone fa-power-off"></i>
        </div>
        <template #content>Log Out</template>
      </MovingTooltip>
    </div>
    <div class="side-menu-content">
      <div v-if="sideMenuItems.flight.active" style="padding:20px;">
        <div @click="$store.state.showDrawer = true">Menu Item One</div>
        <div @click="$store.state.showDrawer2 = true">Menu Item Two</div>
        <div>Menu Item Three</div>
        <div>Menu Item Four</div>
        <div>Menu Item Five</div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">

.side-menu {
  position: fixed;
  z-index: 999999;
  top: 0;
  left: 0;
  height: 100vh;
  width: 0;
  background: #f6f6f6;
  border-left: solid var(--side-menu-color) 50px;
  transition: width 0.45s ease-in-out 0s;
  user-select: none;

}

.side-menu-content {
  position: absolute;
  top: 50px;
  width: max-content;
  padding: 20px 0 10px 0;
  opacity: 0;
  visibility: hidden;
  transition: none;
  font-size: 15px;
}

.side-menu-icon-active {
  color: var(--side-menu-text-color);
  transition: ease-in-out 0.2s;
}

.side-menu-content div {
  padding: 10px 0 0 0;
  user-select: none;
}

//.side-menu:hover {
//  width: 230px;
//  transition-delay: 0.7s;
//}
//
//.side-menu:hover .side-menu-content {
//  visibility: visible;
//  transition: ease-in 0.7s;
//  opacity: 1;
//  transition-delay: 0.7s;
//}

.side-menu-icons {
  margin: 60px 0 0 -42px;
  font-size: 25px;
  width: max-content;
  color: #b3b3b3;
}

.side-menu-logo {
  transform: rotate(270deg);
  width: max-content;
  margin: 400px 0 0 -67px;
  font-size: 24px;
  color: var(--side-menu-text-color);
}

.side-menu-log-out {
  position: absolute;
  left: -42px;
  bottom: 30px;
  font-size: 30px;
  color: #F68E1E;
  cursor: pointer;
}

</style>
